import type { SagaIterator } from 'redux-saga';
import { debounce } from 'redux-saga/effects';

import { resourceSagaUtils, resourceStoreTypes } from '../core';
import * as actions from './investmentSymbolsActions';
import { type InvestmentSymbolProps, mkInvestmentSymbol } from './investmentSymbolsTypes';

type InvestmentSymbolLookupResponse = {
  data?: {
    resources?: InvestmentSymbolProps[];
    results?: InvestmentSymbolProps[];
  };
};

const mkQcsSyncInvestmentSymbolsConfig =
  resourceStoreTypes.createTypedQcsSyncResourcesConfigFactory<InvestmentSymbolProps>();

export function* getInvestmentSymbolsActionWatcher(): SagaIterator {
  const config = mkQcsSyncInvestmentSymbolsConfig({
    resourceName: 'investment symbols lookup',
    resourceBaseUrl: '/v2/investments/symbol-lookup',
    getLastSyncDate: null,
    transformResponseToResources: (response?: InvestmentSymbolLookupResponse | null) =>
      response!.data?.results?.map((item) => mkInvestmentSymbol({ id: item.symbol, ...item })),
    successAction: actions.getInvestmentSymbolsSuccess,
    failureAction: actions.getInvestmentSymbolsFailure,
    axiosConfig: { params: { limit: 50 } },
  });
  yield debounce(
    400,
    actions.getInvestmentSymbols.type,
    resourceSagaUtils.qcsSyncGetResources<InvestmentSymbolProps>,
    config,
  );
}

export default [getInvestmentSymbolsActionWatcher];
